import { createContext } from "react";


const ThemeContext = createContext({
    mode: 'light',
    setMode: (e: any) => { }
});

export default ThemeContext;